export const openWebsite = (url: string): void => {
	const isWwwUrl = !url.includes('https://') && !url.includes('http://');

	window.open(isWwwUrl ? `https://${url}` : url, '_blank');
};
